<script>
import { defineComponent } from 'vue';
import EmailHelpers from '@/helpers/emailValidate.js';
import AuthSrv from '@/services/auth.service.js';

export default defineComponent({
    name: 'forgotPassword',
    setup() {},
    data() {
        return {
            u: "",
            e: "",
        }
    },
    methods: {
        resetPassword() {

            if (this.isValid) {
                AuthSrv.SendResetEmail(this.e, this.u).then((response) => {

                    if (response.status==200) {
                        this.$store.dispatch('message/sendMessage', {message: `An email has been sent with further password reset instructions`, type: 'positive', textColor: 'white', position: 'top', icon: 'person', classes: 'glossy'}, {root:true});
                        this.$router.push('/login')
                    }

                }).catch((e) => {

                    if (e == "Error: Request failed with status code 401") {
                        this.$store.dispatch('message/sendMessage', {message: `Account not found, please review the credentials and try again`, type: 'negative', textColor: 'white', position: 'top', icon: 'person', classes: 'glossy'}, {root:true});
                    }

                })
            }

        },

    },
    computed: {
        isValid() {
            return EmailHelpers.ValidateEmail(this.e) && this.u.length>0 ? true : false;
        }
    }
})
</script>

<template>
<q-layout>

  <q-page-container>
    <div class="bodyContainer q-mt-lg q-gutter-xs" v-if="!displayVerifyCode">
        <div class="row mb-3">
            <div class="col-12">
                <router-link :to="'/'">
                    <img class="mb-4 imgFull" src="@/assets/images/wcwLogoBLACK.png" />
                </router-link>
                <h2 class="text-center mb-3">Forgot Password?</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <form>
                    <div class="loginInput q-mb-lg">
                        <span class="loginInputButton"><i class="fa-lg fas fa-user"></i></span>
                        <input type="text" placeholder="Username" v-model.trim="u">
                    </div><br/>
                    <div class="loginInput">
                        <span class="loginInputButton"><i class="fa-lg fas fa-envelope"></i></span>
                        <input type="email" placeholder="Email Address" v-model.trim="e">
                    </div>
                </form>
            </div>
        </div>
        <div class="row q-mt-md">
            <div class="col-4"></div>

            <div class="col-4 text-center">
                <q-btn :ripple="{ color: 'cyan-7' }" padding="7px 30px 7px 30px" squared class="bgWCWYellow" label="Reset" style="border: 1px solid #666" @click="resetPassword()" :disabled="!isValid"/>
            </div>

            <div class="col-4"></div>
        </div>
    </div>
  </q-page-container>
</q-layout>

</template>
